'use client';

import { useEffect, useRef } from 'react';
import { AI_BETA_STORAGE_KEY } from '@/shared/lib/auth/permissions';

// TEMP — Discord AI-beta opt-in capture. A link shared in the Discord server
// carries `?ai_beta=1`; landing on any page persists the opt-in so the Taboo
// PRO entries show for Discord-linked members (see `canSeeTabooAi`). `0` is
// the kill-switch. Delete this provider (and its layout mount) at GA together
// with the TEMP gate in permissions.ts.
export function AiBetaProvider() {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const value = new URLSearchParams(window.location.search).get('ai_beta');
    if (value !== '1' && value !== '0') return;

    try {
      if (value === '1') window.localStorage.setItem(AI_BETA_STORAGE_KEY, '1');
      else window.localStorage.removeItem(AI_BETA_STORAGE_KEY);
    } catch {
      // Safari private mode / quota exceeded — the opt-in is best-effort.
    }
  }, []);

  return null;
}
